<template>
  <div>
    <b-form-group class="mx-auto">
      <b-form-checkbox-group
        v-model="items"
        class="customCheck2"
        button-variant="light"
        :options="itemsList"
        stacked
        buttons
      >
      </b-form-checkbox-group>
    </b-form-group>
    <b-button 
      v-if="options && options.length > 4"
      variant="link"
      @click="showhide"
    >
      {{show ? "Less": "More"}}
    </b-button>
  </div>
</template>
<script>
export default {
  props: {
    options: Array
  },
  data() {
    return {
      items: [],
      show: false,
      itemsList: []
    };
  },
  methods: {
    showhide(){
      this.show = !this.show
      if (!this.show){
        this.itemsList = this.options.slice(0,4)
      }else{
        this.itemsList = this.options
      }
    }
  },
  created(){
    if(this.options.length > 4){
      this.itemsList = this.options.slice(0,4)
    }else{
      this.itemsList = this.options
    }
  }
};
</script>
<style lang="scss">
.btn-group,
.btn-group-vertical {
  display: block;
}
.customCheck2 label {
  background-color: #ffffff;
  border-color: transparent !important;
  color: var(--color-upp) !important;
  text-align: left;
  font-size: 1em;
  border-radius: 30px !important;
  background-color: #f3f4f9;
  padding: 10px 10px 10px 15px;
}
.customCheck2 label span {
  //text-transform: uppercase !important;
}
.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 8px !important;
}

.customCheck2 .btn-light:not(:disabled):not(.disabled):active,
.customCheck2 .btn-light:not(:disabled):not(.disabled).active,
.customCheck2 .show > .btn-light.dropdown-toggle {
  color: #f3f4f9 !important;
  background-color: var(--color-upp) !important;
  padding: 10px 10px 10px 30px;
}
.customCheck2 .btn-light:not(:disabled):not(.disabled):active::after,
.customCheck2 .btn-light:not(:disabled):not(.disabled).active::after,
.customCheck2 .show > .btn-light.dropdown-toggle::after {
  content: "✓";
  position: absolute;
  left: 10px;
  top: 10px;
}
.customCheck2 .btn:focus,
.btn.focus {
  box-shadow: none !important;
}
.form-group {
  margin-bottom: 0;
}
</style>
